import { useEffect, useState } from 'react';
import './App.css';
import { eventsContent } from './events/content';

const pillars = [
  {
    title: 'GROWING',
    short: 'Growth',
    description:
      'HR Tech 기업과 산업 내 인재들이 성장할 수 있는 기회를 제공하고 글로벌 시장 진출을 지원합니다.',
  },
  {
    title: 'LEARNING',
    short: 'Learning',
    description:
      '글로벌 교육 매체와의 파트너십을 통해 변화하는 기술 동향과 적용 사례를 학습할 수 있습니다.',
  },
  {
    title: 'NETWORKING',
    short: 'Network',
    description:
      'HR Tech Korea의 네트워킹은 워크샵, 컨퍼런스, 강의 등 다양한 방식을 통해서 진행됩니다.',
  },
];

const highlights = [
  { label: 'Pillars', value: 'Growing · Learning · Networking' },
  { label: 'Direction', value: 'Ecosystem + Knowledge Community' },
  { label: 'Focus', value: 'Thought Leadership / Collaboration' },
];


const insightPosts = [
  {
    id: 'hrtech-ecosystem-growth-korea',
    title: '대한민국 HR Tech 기업의 지속적인 성장을 위한 제언',
    excerpt:
      '지난 2023년 HR Tech Seminar를 준비하며 왜 HR Tech 산업생태계 구축이 필요한지, 국내 HR Tech 시장의 구조적 이슈와 성장 전략을 함께 짚어봅니다.',
    category: '오피니언',
    date: '2023-02-05',
    readTime: '12분',
    theme: 'map',
  },
  {
    id: 'peak-matrix-2025-summary',
    title: '[분석보고서] Phenom',
    excerpt:
      '글로벌 리서치 그룹 Everest가 발표한 PEAK Matrix를 바탕으로 Skill 인텔리전스 플랫폼 리더 그룹을 간결하게 정리했습니다.',
    category: '분석 리포트',
    date: '2023-04-14',
    readTime: '6분',
    theme: 'chart',
  },
  {
    id: 'global-hrtech-top20-part2',
    title: '글로벌 HR Tech 및 서비스 회사 Top 20 (2)',
    excerpt:
      '공개 기업 기준 HR Tech 및 서비스 회사 11-20위 구간을 정리하고, 각 기업의 특징과 관전 포인트를 요약합니다.',
    category: '랭킹',
    date: '2026-02-11',
    readTime: '5분',
    theme: 'scatter',
  },
  {
    id: 'global-hrtech-top20-part1',
    title: '글로벌 HR Tech 및 서비스 회사 Top 20 (1)',
    excerpt:
      '시가총액 및 시장 존재감을 기준으로 자주 언급되는 글로벌 HR Tech·서비스 회사를 1-10위 중심으로 정리했습니다.',
    category: '랭킹',
    date: '2026-02-08',
    readTime: '5분',
    theme: 'table',
  },
];

const insightArticleContent = {
  'hrtech-ecosystem-growth-korea': {
    title: '대한민국 HR Tech 기업의 지속적인 성장을 위한 제언',
    category: '오피니언',
    date: '2023-02-05',
    readTime: '12분',
    sourceLabel: '디지털보난자 · HR CAT',
    sourceUrl: 'https://digitalbonanza.co.kr/hrtechstrategy/',
    dek:
      '국내 HR Tech 시장의 구조적 과제와 성장 전략을 짚어보며, 생태계 관점에서 필요한 실행 방향을 제안합니다.',
    introNote:
      '이 글은 2023년 HR Tech Seminar를 기획하며, 국내 HR Tech 산업생태계 구축이 왜 필요한지에 대한 문제의식을 정리한 글입니다.',
    sections: [
      {
        heading: 'HR Transformation에 대한 기업들의 이해와 그 목표는 다 동일하지는 않다.',
        paragraphs: [
          '특히, 세계 경제의 불확실성과 변동성이 어느 때 보다 높기 때문에 개별 기업의 상황에 맞는 변화의 로드맵이 필요한 것은 당연하다. 단, 여전히 불변하는 사실은 HR 분야에서의 혁신과 변화는 계속 진행하고 있다는 점이다.',
          '전 세계를 흔들었던 팬데믹이 끝나가는 이 시점, 지난 3년 정도의 시간을 돌아보면 그 어느 때보다 기업 내외의 혁신의 변화가 강하고 선명하게 일어났던 것을 누구도 부정하지 못할 것이다. 그 중에서도 사람들의 삶, 라이프스타일의 변화와 맞물려 기업의 구성원들에게도 일하는 방식, 일에 대한 의미 그리고 회사와 개인과의 관계에 까지도 근본적인 질문이 있었고 그에 대한 순응과 도전이 있었다. 이러한 변화, 특히 HR 분야에서의 근본적인 변화는 이제 본격적으로 시작되고 있다고 해도 과언이 아니다.',
        ],
      },
      {
        heading: 'HR Tech Startup의 최근 현황',
        paragraphs: [
          '그동안 국내에서도 많은 기업들이 전사적인 DX(디지털 트랜스포메이션)을 가장 중요한 전략적 아젠다로 선택하고 일하는 방식과 고객경험관리에 혁신적 변화를 일으켜 왔다. HR 분야에서도 이러한 흐름에 대응하는 움직임이 나타나기 시작했다.',
          '디지털 트랜스포메이션(DX)이 화두가 되면서 HR 영역에서도 데이터를 기반으로 하는 의사결정 시스템을 구축하고 직원경험관리를 위한 다양한 솔루션들이 도입되기 시작했다.',
          '그 결과, 대기업을 중심으로 글로벌 HR SaaS 솔루션을 도입하여 글로벌 조직의 통합 HR운영의 기반을 갖추기 시작했고 중소규모의 기업에 최적화된 국내 HR SaaS 솔루션들도 성장의 기회를 맞이했다. 특히 정부의 코로나 지원 정책의 하나로 기업들에게 각종 바우처를 제공하는 사업들은 새로운 서비스가 빠르게 시장에 소개되는 계기가 되었다.',
          '이러한 환경 조성 하에서 자연스럽게 HR Tech 분야의 스타트업들이 등장하기 시작했다. 기존의 대기업과 다른 조직문화를 표방하는 젊은 창업가들은 스스로 차별화된, 독립적인 생태계를 조성해 갔고 이러한 스타트업들 대상으로 한 특화된 HR 솔루션들도 나오기 시작했다.',
          '이러한 HR Tech 성장의 배경에는 물론 투자자들의 움직임도 큰 영향을 미쳤다. 한동안 HR Tech 는 ‘넥스트 황금알’이라고 불릴 정도로 VC들의 뜨거운 관심 영역이었다.',
          '다른 관점에서는 현재 HR Tech 산업의 활황을 언번들링에서 이야기하기도 한다. 언번들링은 기존의 토탈 솔루션을 지향했던 거대 엔터프라이즈 솔루션들의 플랫폼에서 특정 서비스나 영역을 깊게 파고드는 버티컬 플랫폼의 등장으로 이해할 수 있다. 최근 HR Tech 시장에서는 특히 채용 관련 솔루션들의 급격하게 증가한 것을 볼 수 있고 OKR을 시스템으로 구현한 성과관리 솔루션에서도 그 사례를 볼 수 있다.',
          '국내 리딩 액셀러레이터 중의 한 곳은 이러한 시장의 흐름에 빠르게 대응하며 HR 스타트업을 인수하여 미래인재연구소를 설립하고 HR 관련 스타트업을 육성하는 것 뿐 아니라 인재들을 양성해서 공급하는 새로운 비즈니스 라인을 런칭하기도 했다.',
          '돈이 몰리고 인재들이 몰리며 더 많은 사업 기회들이 창출되는 선순환의 과정에 들어가는 것 처럼 보였고 모두들 HR Tech의 가능성에 대해 확신을 하는 분위기였다.',
          '그러나, 2022년 상반기부터 일어난 투자환경의 변화와 얼어붙은 투자심리는 이 모든 것을 바꾸어 버렸다.',
        ],
        figure: {
          src: 'https://cdn.media.bluedot.so/bluedot.digitalbonanza/2023/02/s6cx07_%E1%84%89%E1%85%B3%E1%84%8F%E1%85%B3%E1%84%85%E1%85%B5%E1%86%AB%E1%84%89%E1%85%A3%E1%86%BA_2023-02-04_%E1%84%8B%E1%85%A9%E1%84%92%E1%85%AE_11.32.15.png',
          alt: 'HR Tech 관련 투자/시장 흐름 이미지',
          caption: '출처: https://www.hankyung.com/it/article/202206029886i',
        },
      },
      {
        heading: '투자보다 심각한 구조적인 모순',
        paragraphs: [
          '갑작스러운 투자환경의 변화는 많은 국내 뿐 아니라 글로벌하게 많은 Tech 스타트업에게는 패닉으로 다가왔다.',
          '글로벌하게는 전년동기 대비 -64%의 투자금액이 감소되었고 국내에서도 3분기 기준 YoY 로 -35%의 감감으로 말그대로 꽁꽁 얼어붙은 상황이 되었다.',
          '지금 필요한 것은 현실을 냉정하게 보고 생존 전략을 세우는 것이며 동시에 그동안 알면서도 크게 신경쓰지 않았던 현재 국내 HR Tech 시장이 내재하고 있는 구조적 모순을 해결하기 위한 노력을 시작해야 한다.',
          '동시에 HR Tech도 B2B SaaS Application 이라는 더 큰 카테고리에서의 성장 전략을 다시 세워야 하고, 다른 산업 섹터의 선행적 시행착오와 성장의 사례를 면밀하게 살펴서 교훈으로 삼아야 한다.',
          '우선, 현재 국내 HR 서비스 산업에 내재되어 있는, HR Tech 와 관련된 모순에 대해서 살펴보자.',
        ],
        source: '출처: http://www.hanaif.re.kr/boardDetail.do?menuId=MN2100&tabMenuId=MN2104&hmpeSeqNo=35551',
        figure: {
          src: 'https://cdn.media.bluedot.so/bluedot.digitalbonanza/2023/02/w18y7g_%E1%84%89%E1%85%B3%E1%84%8F%E1%85%B3%E1%84%85%E1%85%B5%E1%86%AB%E1%84%89%E1%85%A3%E1%86%BA_2023-02-04_%E1%84%8B%E1%85%A9%E1%84%92%E1%85%AE_11.35.25.png',
          alt: '투자 환경 변화 관련 그래프 캡처',
          caption: '출처: http://www.hanaif.re.kr/boardDetail.do?menuId=MN2100&tabMenuId=MN2104&hmpeSeqNo=35551',
        },
      },
      {
        heading: '한국 경제 구조의 모순에 부딪힌 HR Tech 회사의 어려움',
        paragraphs: [
          '대부분의 HR Tech 스타트업들이 갖고 있는 비즈니스 모델은 B2B 시장을 타겟으로 SaaS 기반의 클라우드 서비스 형태다. 구독형 서비스 이기 때문에 필요한 만큼 고객사가 비용을 지불하고 쓰는 개념이다. 이전처럼 라이센스를 받고 소프트웨어를 공급하는 방식이 아니라 대부분 유저 단위로 구독하는 기간만큼 과금하게 된다. 기업 입장에서는 초기 지불해야 하는 비용이 낮고 별도의 하드웨어나 네트워크에 대한 투자가 필요하지 않기 때문에 도입에 대한 의사결정 부담이 크지 않지만 구독해야 하는 유저 규모와 기간에 따라서는 많은 돈을 쓰게 된다.',
          '공급자인 서비스 제공 회사의 입장에서는 클라우드 환경에서 서비스와 솔루션 개발에 많은 투자를 해야 하지만 상용화 이후 손익분기점을 넘어서는 순간 부터의 고객 매출(구독)은 모두 이익으로 전환될 수 있기 때문에 적정한 규모의 고객풀을 확보하게 되면 일단, 생존의 기반을 마련할 수 있게 된다.',
          '문제는 바로 그 규모를 확보하는 것이 쉽지 않다는 것이다.',
          '현재 국내 HR Solution, HR Tech 산업에서 가장 어려운 점 중의 하나는 서비스 구독료, 즉 고객이 지불하는 시장의 가격이 너무 낮게 형성되어 있다는 것이다.',
        ],
      },
      {
        heading: '1. 급여 아웃소싱으로 형성된 HR 서비스 가격의 앵커 효과',
        paragraphs: [
          '심리학과 행동경제학에서 이야기하는 앵커 효과란 기존에 경험했던 것을 근거로 형성된 참조가격(Reference price)를 기준으로 가격의 적절성을 판단하는 인간 내면의 비합리적 특성을 말한다. 어느 가격에 가치를 부여할 때 먼저 가격을 제시하는 쪽의 금액을 기준으로 협상이 시작되는 것을 예로 들 수 있다. 적정 가격이 얼마인지상관없이 먼저 제시되는 호가를 기준으로 높이고 낮추게 되기 때문에 처음 제시되는 가격이 앵커 효과를 발휘하게 된다고 이야기 하는 것이다.',
          '현재 이러한 앵커 효과를 발휘하는 것이 바로 급여아웃소싱에 대한 서비스 비용이다.',
          '현재 대략적인 급여아웃소싱 서비스에 대한 월별 1인당 비용은 10,000원에서 15,000원 수준으로 형성되어 있다. 전문적인 아웃소싱회사들도 있지만 소규모 회사의 경우에는 세무사들의 세무기장 서비스에 포함해서 처리되는 경우도 많다. 아이러니 한 것은 25여년전 국내 급여 아웃소싱 현황 조사를 했을 때 파악된 비용과 거의 동일하다는 점이다.',
          '현재 대부분의 HR Tech 솔루션의 서비스 구독료도 이 가격대에 몰려 있다. 만약 어떤 새로운 서비스를 고객사에 제안한다면 HR 담당은 “저희가 지금 인당 1명에 대해 급여 서비스로 지불하는 게 1만원 인데요. 그에 비한다면...” 이라는 답을 듣기 쉽다.',
          '한국의 HR 서비스 시장은 크게 써치펌이나 헤드헌터와 같은 채용서비스와 교육컨텐츠 또는 교육과정 공급과 관련한 것, 플렉서블 베네핏과 같은 복리후생 서비스 그리고 연말정산을 포함하는 급여행정 아웃소싱 서비스로 구분해 볼 수 있다. 이 중에서 HR 데이터에 대한 처리 및 시스템이 연결되고 Head count, 명수를 기준으로 가격을 책정하는 것이 급여 아웃소싱이다.',
          '새로운 HR SaaS의 클라우드 HRMS 를 제안하는 경우에도 동일한 구조, 인당 월별 비용으로 제안하게 되기 때문에 그 가치와 기능의 차이 등과 관련없이 기업 고객의 준거 가격으로 작동된다.',
          '기술의 발전이 급여 프로세싱 업무의 대부분을 자동화하였고 그래서 이전에 비해 더 적은 인력의 투입으로 더 빠르고 정확하게 업무처리가 가능해 졌기 때문에 비용 원가 측면에서는 더 높아질 요인이 없었을 수도 있다. 그렇기 때문에 급여아웃소싱 업무의 가격 적절성에 대한 문제제기는 결코 아니다. 그러나, 전면적인 시스템의 변화, 차별화된 기능의 개발과 구성, 탁월한 UI/UX 등을 아무리 이야기 해도 일단 고객사의 준거 가격의 범위 내에 있지 않으면 비싸다는 피드백을 듣게 된다.',
          '현재로서는 이 가격에 대한 저항감을 극복할 뾰족한 솔루션은 없어 보인다. 대부분의 SaaS 구독료가 월10불 내외에서 형성되어 있다는 점도 그렇다. 문제는 이 가격으로 국내 HR Tech 기업들이 적정 매출규모를 확보하기위해 타겟할 소위 SOM(Serviceable Obtainable Market)이 충분하지 않다는 점이다.',
        ],
        figures: [
          {
            src: 'https://digitalbonanza.co.kr/wp-content/uploads/2023/02/image-10-1024x608.png',
            alt: '급여 아웃소싱 시장 규모 및 관련 지표 차트',
            caption: '급여 아웃소싱 가격 구조와 시장 맥락을 설명하는 원문 차트 캡처',
          },
          {
            src: 'https://digitalbonanza.co.kr/wp-content/uploads/2023/02/image-6-1024x619.png',
            alt: 'HR 서비스 가격 앵커 효과와 관련된 비교 차트',
            caption: '앵커 효과 논의를 보완하는 원문 데이터/차트 캡처',
          },
        ],
      },
      {
        heading: '2. 적정 규모를 확보하기 어려운 산업구조',
        paragraphs: [
          '중기업 이상 기업수 11만개, 800만명 규모의 직원 수 그러나 전체의 1.5% 수준',
          '현재 2022년에 발표된 정부의 자료를 보면 2020년 기준 한국 내 기업수 729만여개 중 중기업, 대기업의 비중은 1.5%로 11만개 정도이다. 종사자 수 기준으로 보면 36.3%로 약 780만명 정도이다.',
          '2020년 기준 중소기업 현황 [표-중기부]',
          'HR Tech 기업의 SAM(Serviceable Available Market)은 서비스의 타겟 시장에 따라 다르다. 대기업의 경우 이미 글로벌 HR SaaS 또는 온프레미스의 HR 솔루션을 도입한 비중이 높기 때문에 HRMS 보다는 버티컬 플랫폼이나 포인트 솔루션이 적합하고 All in one 형태의 HRMS의 경우에는 중기업을 타겟으로 하게 될 가능성이 높다. 그럴 경우 결국 SAM 은 중기업 이상 전체보다는 작을 수 밖에 없다.',
          '구독형의 특성을 감안 시 인당 15,000원, 12개월 기준으로 계산한다면 100명 규모의 회사를 500개 확보해야 연간 90억 매출이 가능하다. 최근 HR Tech 회사 중에서 가장 주목을 받았던 플렉스가 2022년 1월 3500억원의 기업가치를 인정받았다는 기사가 있었는데, 고객풀과 매출 규모에 대해 공개된 자료가 없어 어느 정도의 사용자 규모에 다다랐는지 확인할 수는 없다.',
          '단, 한국의 급여 아웃소싱에서 가장 큰 규모의 고객풀을 확보한 메타페이(www.metapay.co.kr)가 180여개사 22만명을 대상으로 서비스를 제공하는 것을 감안한다면 HR Tech 기업이 한국 시장에서 100억 이상의 매출을 내는 기업은 손에 꼽을 정도 일 것으로 예상된다.',
          'Meta Pay website(www.metapay.co.kr)',
          '그에 비교한다면 글로벌 HR Tech 기업들의 규모는 차원이 다르다.',
          '데카콘으로 평가 받고 있는 Deel 의 경우 2023년 현재 시점에서 1만5천여개의 고객사를 확보했고 ARR(연간누적반복매출) 2022년말 기준 2억9천만불, 한화로 3500억원에 달한다.',
        ],
        figures: [
          {
            src: 'https://cdn.media.bluedot.so/bluedot.digitalbonanza/2023/02/yj9e4p_image.png',
            alt: '2020년 기준 중소기업 현황 표',
            caption: '2020년 기준 중소기업 현황 [표=중기부]',
          },
          {
            src: 'https://cdn.media.bluedot.so/bluedot.digitalbonanza/2023/02/h62akr_%E1%84%89%E1%85%B3%E1%84%8F%E1%85%B3%E1%84%85%E1%85%B5%E1%86%AB%E1%84%89%E1%85%A3%E1%86%BA_2023-02-04_%E1%84%8B%E1%85%A9%E1%84%92%E1%85%AE_11.40.22.png',
            alt: 'Meta Pay website 캡처',
            caption: 'Meta Pay website (www.metapay.co.kr)',
          },
        ],
      },
      {
        heading: '한국 HR Tech 기업들의 지속 경영을 위한 전략적 옵션',
        paragraphs: [
          '우선 생존을 위해서는 적정 규모를 키워서 손익분기점을 넘어야 하는 HR Tech 기업들에게 소위 J 커브를 그리는 성장의 곡선을 만들어내기는 쉽지 않다. 한 국내 HR Tech 회사의 경우 정부의 바우처 사업을 통해서 중소기업의 고객을 한동안 확보해 왔지만 정해진 지원 기간이 종료가 되면 비용부담을 이유로 바로 구독을 중단하는 어려운 상황을 맞이하고 있다는 이야기가 들린다. 구독형 SaaS 서비스가 갖고 있는 특성이 역으로 작동하는 경우다.',
          '한국의 HR Tech 기업들이 지속적으로 성장하기 위해서는 어떤 전략적 선택이 가능할까?',
        ],
      },
      {
        heading: '1. 보유한 서비스와 기술을 다른 회사에 매각',
        paragraphs: [
          '가장 현실적인 방안은 M&A를 통해 더 큰 솔루션의 일부가 되거나 이미 거대 고객풀을 확보한 기업의 새로운 서비스로 규모를 빠른 시간 안에 키우는 것이다. 논리는 명쾌하나 실제로는 한국 스타트업, 특히 HR Tech에서는 사례를 찾기 힘든 것도 사실이다. 글로벌 마켓에서는 소위 합종연횡이 빈번하게 일어나고 특히 자본력을 갖추 HR Tech 상장회사들의 경우 적극적으로 특화된 솔루션을 개발한 스타트업들을 인수하여 시장과 고객의 니즈에 빠르게 대응하고 있다. 현재 한국의 HR Tech가 하나의 산업군으로 자리 잡고 글로벌 경쟁력을 확보하기 위해서는 오가닉(Organic) 성장만이 아니라 인오가닉(Inorganic) 성장을 적극적으로 고려하는 회사들이 더 증가되어야 할 것이다.',
          '2022년 글로벌로 1600개 이상의 HR Tech 기업의 M&A 딜이 있었는데 2021년 대비해서는 56% 증가된 숫자다.',
        ],
        source: '출처: www.hrtech.sg',
        figure: {
          src: 'https://cdn.media.bluedot.so/bluedot.digitalbonanza/2023/02/ifu0u8_%E1%84%89%E1%85%B3%E1%84%8F%E1%85%B3%E1%84%85%E1%85%B5%E1%86%AB%E1%84%89%E1%85%A3%E1%86%BA_2023-02-04_%E1%84%8B%E1%85%A9%E1%84%92%E1%85%AE_11.43.00.png',
          alt: '2022 HRTech M&A Deal Tracker 캡처',
          caption: '출처: www.hrtech.sg',
        },
      },
      {
        heading: '2. 한국 시장을 넘어서 다른 해외 마켓으로 진출',
        paragraphs: [
          '한 시장의 성장 잠재력을 내가 만들 수 없다면 더 큰 시장으로의 진출을 고려하는 것은 당연하다. B2B SaaS로 유니콘에 등극한 샌드버드의 사례에서 처럼 초기에 미국과 같은 더 큰 시장에서 본격적인 사업을 전개하고 투자를 유치하는 것을 HR Tech 스타트업들도 적극적으로 고려해야 한다.',
          '이 전략에는 분명 넘어야 하는 몇가지 허들이 있다.',
          'SEO를 더 강화하고 글로벌 앱마켓에 확장하는 것 만으로는 충분하지 않다. 특히 Employee data를 다루는 HR관련 서비스나 솔루션의 경우 유럽의 GDPR이나 다른 보안관련 요구수준이 더 높고 엄격하다는 것도 기억해야 한다. 무엇보다 독자적인 영업망을 갖추고 로컬 고객의 요구수준에 대응하기 어렵기 때문에 적정한 파트너를 발굴하고 협의의 관계를 구축하는 것이 필수다.',
        ],
      },
      {
        heading: '3. 글로벌 HR Tech 기업의 마켓플레이스와 글로벌 솔루션의 인증제도 활용',
        paragraphs: [
          '우선 고려할 수 있는 옵션은 글로벌 HR Tech 대기업의 생태계와 플랫폼으로 적극 진입하는 것이다.',
          '북미 최대 HR 서비스 회사인 ADP는 HR관련 솔루션을 검색하고 구매를 진행할 수 있는 마켓플레이스를 운영 중에 있다. 꼭 ADP 의 고객사가 아니더라도 이 플랫폼을 이용해 다양한 HR Tech 회사를 검색하고 상세 정보를 찾을 수 있으며 구매나 데모 요청 등을 할 수 있다.',
          'ADP가 구축한 생태계의 규모와 다양함, 그리고 HR Tech 시장에서 경쟁과 협업의 관계를 만들어 가는 노력은 더 높은 차원의 고객 가치를 만들어 내고 있고 HR Tech 기업들이 글로벌한 경쟁력을 갖추도록 하고 있다. 이 마켓플레이스 자체가 HR Tech 기업의 DB 역할을 하고 있다. 현재 한국의 HR Tech가 발전하기 위해서 절실하게 필요한 부분이라고 할 수 있다.',
          '글로벌 Tech 기업과 파트너십을 형성하는 다른 방법은 그들의 Certification 제도를 적극 활용하는 것이다.',
          'ADP 의 경우 오픈된 형태로 ADP의 경쟁관계에 있는 솔루션이라고 해도 마켓플레이스에 등록이 가능하다면 SAP나 Workday 의 경우에는 기존 자사의 솔루션에 인터페이스가 가능한 API 나 익스텐션의 솔루션을 대상으로 마켓플레이스와 SAP Store 를 운영하고 있다. 이 경우에는 우선 Certified partner의 자격을 신청하고 SAP나 Workday와 연동이 가능한 API를 개발하여 등록나는 추가적인 조치가 필요하다.',
          '한국의 HR Tech 회사들이 대기업 또는 글로벌 기업들을 대상으로 영업을 한다면 유리할 수 밖에 없다. 모 회사에서도 SAP의 Payroll에 대한 Certified 파트너 자격을 획득하고 유수 글로벌기업들과의 계약이 급격하게 증가하고 인바운드로 많은 문의를 받는 것을 확인할 수 있었다.',
        ],
        figure: {
          src: 'https://cdn.media.bluedot.so/bluedot.digitalbonanza/2023/02/lthdk1_%E1%84%89%E1%85%B3%E1%84%8F%E1%85%B3%E1%84%85%E1%85%B5%E1%86%AB%E1%84%89%E1%85%A3%E1%86%BA_2023-02-04_%E1%84%8B%E1%85%A9%E1%84%92%E1%85%AE_11.46.21.png',
          alt: 'ADP Marketplace 관련 캡처',
          caption: 'ADP Marketplace 관련 화면 캡처',
        },
      },
      {
        heading: '4. HR Tech 기업간의 네트워킹과 상호 협력관계 확대',
        paragraphs: [
          '글로벌 HR 서비스 기업들의 경우에는 자신들의 고객사들에게 다른 회사의 솔루션과 서비스를 소개하고 그에 따른 계약이 성사되는 경우 인센티브를 주는 방식을 적극 활용하고 있다. Referral partnership 또는 인센티브 프로그램이라고 하는 제도를 통해 고객의 인바운드 Lead를 확대하는 것이다.',
          '이런 기브앤테이크 방식 외에도 좀더 장기적인 안목으로 한국 내 HR Tech 기업들이 서로 간의 정보를 교환하고 공동 마케팅을 전개할 수 있는 커뮤니티를 구축하는 것도 필요하다.',
          '한국 HR Tech 기업의 협력관계를 증진하고 정보를 공유하는 커뮤니티 구축에 대해서는 디지털보난자가 주관하여 준비하고 있는 4월 6일의 HR Tech 컨퍼런스를 좀 더 자세하게 공유할 예정이다.',
        ],
        source: '출처: https://www.globalization-partners.com/submit-a-referral-emea/',
        figure: {
          src: 'https://cdn.media.bluedot.so/bluedot.digitalbonanza/2023/02/t42bzb_%E1%84%89%E1%85%B3%E1%84%8F%E1%85%B3%E1%84%85%E1%85%B5%E1%86%AB%E1%84%89%E1%85%A3%E1%86%BA_2023-02-04_%E1%84%8B%E1%85%A9%E1%84%92%E1%85%AE_11.59.48.png',
          alt: 'Referral partnership 관련 캡처',
          caption: '출처: https://www.globalization-partners.com/submit-a-referral-emea/',
        },
      },
      {
        heading: '결론',
        paragraphs: [
          '이제까지 개별 기업들이 각자 자신들만의 힘으로 고객을 개발하고 사업을 성장시켜 왔다면 이제 부터는 HR Tech 기업들이 참여하는 커뮤니티와 플랫폼의 구축을 통해 향후 글로벌 진출, 고객 데이터의 공유, 공동 마케팅과 고객 초청 행사를 실행해 보는 것이 필요하다.',
          '이를 위해 이미 어느 정도 규모에 다다른 기업들의 적극적인 참여와 투자는 이제 막 걸음을 내딛고 있는 스타트업들에게 큰 도움이 될 것이다. HR Tech 기업 뿐 아니라 고객, 파트너, 투자자 들도 참여하는 진정한 상생의 생태계가 구축되어 한국의 HR Tech가 글로벌 경쟁에서 입지를 확보할 수 있기를 기대해 본다.',
        ],
      },
    ],
    note:
      '원문의 논지와 문단 구조를 유지하되, 웹 가독성에 맞춰 제목과 문장을 정리했습니다.',
  },
};

function getCurrentPage() {
  if (typeof window === 'undefined') return 'main';
  const rawPath = window.location.pathname || '/';
  const path = rawPath.replace(/\/+$/, '') || '/';
  if (path === '/insights' || path.startsWith('/insights/')) return 'insights';
  return path.endsWith('/events') ? 'events' : 'main';
}

function getCurrentInsightSlug() {
  if (typeof window === 'undefined') return null;
  const rawPath = window.location.pathname || '/';
  const path = rawPath.replace(/\/+$/, '') || '/';
  if (!path.startsWith('/insights/')) return null;
  const slug = path.replace('/insights/', '').trim();
  return slug || null;
}

function VideoBackground() {
  return (
    <>
      <div className="bg-video-layer" aria-hidden="true">
        <video className="bg-video" autoPlay muted loop playsInline preload="auto">
          <source src="/saas-bg-loop.mp4" type="video/mp4" />
        </video>
      </div>
      <div className="bg-video-tint" aria-hidden="true" />
    </>
  );
}

function SearchControl() {
  return (
    <div className="nav-search" role="search" aria-label="사이트 검색">
      <button type="button" className="search-trigger" aria-label="Search">
        <span className="search-label">Search</span>
        <svg className="search-icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
          <circle cx="11" cy="11" r="6.5" fill="none" stroke="currentColor" strokeWidth="2" />
          <path d="M16 16L21 21" fill="none" stroke="currentColor" strokeWidth="2" />
        </svg>
      </button>
    </div>
  );
}

function SiteHeader({ currentPage, overlay = false }) {
  return (
    <header className={`apple-nav${overlay ? ' is-overlay' : ''}`}>
      {!overlay ? <SearchControl /> : null}
      <nav className="nav" aria-label="주요 메뉴">
        <a className={currentPage === 'main' ? 'is-active' : ''} href="/">
          MAIN
        </a>
        <a className={currentPage === 'insights' ? 'is-active' : ''} href="/insights">
          INSIGHTS
        </a>
        <a className={currentPage === 'events' ? 'is-active' : ''} href="/events">
          EVENTS
        </a>
        <a href="/#contact">CONTACT</a>
      </nav>
    </header>
  );
}

function TopFestivalBanner() {
  return (
    <div className="top-banner-wrap">
      <a
        className="top-banner-link"
        href="https://www.hrtechfestivalasia.com/register"
        target="_blank"
        rel="noreferrer"
      >
        <video className="top-banner-video" autoPlay muted loop playsInline preload="metadata" aria-hidden="true">
          <source src="/banner/top-banner-accent.mp4" type="video/mp4" />
        </video>
        <span className="top-banner-video-scrim" aria-hidden="true" />
        <div className="top-banner-copy">
          <div className="top-banner-headline-row">
            <span className="top-banner-badge">EVENT</span>
            <span className="top-banner-arrow" aria-hidden="true">
              ↗
            </span>
          </div>
          <span className="top-banner-text">
            HR Tech Festival Asia 2026 등록 오픈 · 지금 사전 등록을 시작하세요
          </span>
          <span className="top-banner-subtext">4-7 May 2026 · Suntec Singapore</span>
        </div>
      </a>
    </div>
  );
}

function MainPage() {
  const featuredInsights = insightPosts.slice(0, 3);

  return (
    <main className="page-main page-main-editorial">
      <section className="hero hero-editorial" id="top">
        <p className="eyebrow">HRTechKorea</p>
        <h1>Build the Next HR Tech Standard.</h1>
        <p className="hero-description">
          한국 HR Tech 생태계를 연결하고, 배움과 실행이 일어나는 커뮤니티를 만듭니다.
        </p>
        <div className="hero-actions">
          <a className="button button-primary" href="/events">
            EVENTS
          </a>
          <a className="button button-secondary" href="/insights">
            INSIGHTS
          </a>
        </div>
      </section>

      <section className="main-metric-strip" aria-label="핵심 방향성">
        {highlights.map((item) => (
          <div className="main-metric-item" key={item.label}>
            <p>{item.label}</p>
            <strong>{item.value}</strong>
          </div>
        ))}
      </section>

      <section className="main-pillars-lines" id="pillars">
        <div className="main-section-head">
          <p className="eyebrow">Three Pillars</p>
          <h2>Growing. Learning. Networking.</h2>
        </div>
        <div className="pillar-line-list">
          {pillars.map((pillar, index) => (
            <article className="pillar-line-item" key={pillar.title}>
              <span className="pillar-line-index">0{index + 1}</span>
              <h3>{pillar.title}</h3>
              <p>{pillar.description}</p>
              <span className="pillar-line-arrow" aria-hidden="true">
                ↗
              </span>
            </article>
          ))}
        </div>
      </section>

      <section className="main-video-band" id="vision">
        <div className="main-video-copy">
          <p className="eyebrow">Featured Video</p>
          <h2>
            HR Tech Korea
            <br />
            in Motion
          </h2>
          <p>커뮤니티의 분위기와 실행 중심 네트워크를 영상으로 확인하세요.</p>
          <a
            className="button button-secondary"
            href="https://www.youtube.com/watch?v=hqlMZeE4BQA"
            target="_blank"
            rel="noreferrer"
          >
            YouTube에서 보기
          </a>
        </div>

        <iframe
          className="main-video-embed"
          src="https://www.youtube-nocookie.com/embed/hqlMZeE4BQA?rel=0&modestbranding=1"
          title="HR Tech Korea 소개 영상"
          loading="lazy"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        />
      </section>

      <section className="main-editorial-list" id="insights">
        <div className="main-section-head">
          <p className="eyebrow">Insights</p>
          <h2>Latest from HR Tech Korea</h2>
        </div>
        <div className="editorial-list">
          {featuredInsights.map((post, index) => (
            <a className="editorial-list-item" href={`/insights/${post.id}`} key={post.id}>
              <span className="editorial-index">0{index + 1}</span>
              <div>
                <h3>{post.title}</h3>
                <p>{post.excerpt}</p>
              </div>
              <span className="editorial-meta">{post.date}</span>
            </a>
          ))}
        </div>
        <a className="button button-secondary" href="/insights">
          모든 인사이트 보기
        </a>
      </section>

      <section className="main-events-band">
        <p className="eyebrow">Events</p>
        <h2>HR Tech Festival Asia 2026</h2>
        <p>행사 개요, 프로그램, 등록 정보를 한국어로 정리한 전용 페이지를 운영 중입니다.</p>
        <a className="button button-primary" href="/events">
          이벤트 페이지 열기
        </a>
      </section>

      <section className="contact-section contact-section-apple" id="contact">
        <div className="contact-copy">
          <p className="eyebrow">Contact</p>
          <h2>
            Partner with
            <br />
            HR Tech Korea
          </h2>
          <p>행사 협업, 콘텐츠 제휴, 파트너십 제안을 환영합니다.</p>
        </div>
        <div className="contact-panel contact-panel-apple">
          <a className="button button-primary" href="mailto:hello@hrtechkorea.com">
            hello@hrtechkorea.com
          </a>
          <a className="button button-secondary" href="/events">
            EVENTS 보러가기
          </a>
          <small>응답이 빠른 채널로 연결해 드립니다.</small>
        </div>
      </section>
    </main>
  );
}

function InsightsThumbnail({ theme, title }) {
  return (
    <div className={`insights-thumb insights-thumb-${theme}`} aria-hidden="true">
      <div className="thumb-overlay-grid" />
      <div className="thumb-chip">{title.split(' ')[0]}</div>
      <div className="thumb-shape thumb-shape-a" />
      <div className="thumb-shape thumb-shape-b" />
      <div className="thumb-lines" />
    </div>
  );
}

function InsightsPage() {
  return (
    <main className="page-insights" id="top">
      <section className="insights-page-hero">
        <p className="eyebrow">HR Tech Korea Insights</p>
        <h1>Insights</h1>
        <p className="insights-page-subtitle">
          국내외 HR Tech 산업 동향과 분석 리포트를 큐레이션해, 실무에 바로 연결되는 인사이트를 제공합니다.
        </p>
        <div className="insights-topic-chips" aria-label="주요 토픽">
          <span>HR Tech</span>
          <span>Worktech & AI</span>
          <span>People Analytics</span>
          <span>Workforce Transformation</span>
          <span>Global Trends</span>
        </div>
      </section>

      <section className="insights-blog-list" aria-label="인사이트 글 목록">
        <div className="insights-list-head">
          <div>
            <p className="eyebrow">Latest Posts</p>
            <h2>블로그 형태로 보는 인사이트 아카이브</h2>
          </div>
          <p>
            핵심 주제를 빠르게 파악할 수 있도록 4개의 대표 글을 우선 배치했습니다. 각 글은 요약과
            메타 정보를 제공하며 상세 페이지에서 전체 내용을 확인할 수 있습니다.
          </p>
        </div>

        <div className="insights-card-grid">
          {insightPosts.slice(0, 4).map((post) => (
            <a className="insights-post-card-link" href={`/insights/${post.id}`} key={post.id}>
              <article className="insights-post-card">
                <div className="insights-post-thumb-wrap">
                  <InsightsThumbnail theme={post.theme} title={post.title} />
                </div>
                <div className="insights-post-body">
                  <div className="post-meta compact">
                    <span>{post.category}</span>
                    <span>{post.date}</span>
                  </div>
                  <h3>{post.title}</h3>
                  <p>{post.excerpt}</p>
                </div>
              </article>
            </a>
          ))}
        </div>
      </section>

      <section className="insights-page-footer-card">
        <div>
          <p className="eyebrow">운영 방향</p>
          <h2>분석형 콘텐츠 중심의 인사이트 허브</h2>
          <p>
            산업 리포트, 시장 해설, 케이스 스터디를 중심으로 신뢰도 높은 콘텐츠를 지속적으로
            업데이트합니다.
          </p>
        </div>
        <a className="button button-secondary" href="/#contact">
          인사이트 제휴/문의
        </a>
      </section>
    </main>
  );
}

function InsightsArticlePage({ slug }) {
  const article = insightArticleContent[slug];

  if (!article) {
    return (
      <main className="page-insights" id="top">
        <section className="insights-article-shell">
          <p className="eyebrow">Insights</p>
          <h1>글을 찾을 수 없습니다.</h1>
          <p className="insights-article-dek">
            요청한 글이 아직 등록되지 않았습니다. 목록 페이지에서 다른 글을 확인해주세요.
          </p>
          <a className="button button-secondary" href="/insights">
            인사이트 목록으로 돌아가기
          </a>
        </section>
      </main>
    );
  }

  return (
    <main className="page-insights" id="top">
      <article className="insights-article-shell">
        <a className="insights-back-link" href="/insights">
          ← Insights 목록
        </a>

        <header className="insights-article-header">
          <p className="eyebrow">Insights</p>
          <h1>{article.title}</h1>
          <p className="insights-article-dek">{article.dek}</p>
          <div className="post-meta">
            <span>{article.category}</span>
            <span>{article.date}</span>
            <span>{article.readTime}</span>
            <span>{article.sourceLabel}</span>
          </div>
        </header>

        {article.introNote ? (
          <p className="insights-article-intro-note">{article.introNote}</p>
        ) : null}

        <div className="insights-article-cover">
          <InsightsThumbnail theme="map" title={article.title} />
        </div>

        <div className="insights-article-body">
          {article.sections.map((section) => (
            <section className="insights-article-section" key={section.heading}>
              {section.heading ? <h2>{section.heading}</h2> : null}
              {section.paragraphs.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
              {section.bullets ? (
                <ul>
                  {section.bullets.map((bullet) => (
                    <li key={bullet}>{bullet}</li>
                  ))}
                </ul>
              ) : null}
              {section.source ? <p className="insights-article-source">{section.source}</p> : null}
              {section.figures ? (
                <div className="insights-article-figure-grid">
                  {section.figures.map((figure, index) => (
                    <figure className="insights-article-figure" key={`${section.heading}-figure-${index}`}>
                      {figure.src ? (
                        <img src={figure.src} alt={figure.alt || figure.title || ''} loading="lazy" />
                      ) : (
                        <InsightsThumbnail theme={figure.theme} title={figure.title} />
                      )}
                      {figure.caption ? <figcaption>{figure.caption}</figcaption> : null}
                    </figure>
                  ))}
                </div>
              ) : null}
              {section.figure ? (
                <figure className="insights-article-figure">
                  {section.figure.src ? (
                    <img
                      src={section.figure.src}
                      alt={section.figure.alt || section.figure.title || ''}
                      loading="lazy"
                    />
                  ) : (
                    <InsightsThumbnail theme={section.figure.theme} title={section.figure.title} />
                  )}
                  {section.figure.caption ? <figcaption>{section.figure.caption}</figcaption> : null}
                </figure>
              ) : null}
            </section>
          ))}
        </div>

        <footer className="insights-article-footer">
          <div className="mini-note-card">
            <strong>원문 출처</strong>
            <p>
              원문 링크와 함께 핵심 내용을 확인할 수 있습니다.
            </p>
            <a href={article.sourceUrl} target="_blank" rel="noreferrer">
              원문 보기
            </a>
          </div>
          <div className="mini-note-card">
            <strong>편집 노트</strong>
            <p>{article.note}</p>
          </div>
        </footer>
      </article>
    </main>
  );
}

function EventsPage() {
  const [activeTrackId, setActiveTrackId] = useState(eventsContent.tracks[0].id);
  const [activeSectionId, setActiveSectionId] = useState(eventsContent.nav[0].id);

  useEffect(() => {
    const targets = document.querySelectorAll('.page-events-redesign [data-reveal]');
    const revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('is-visible');
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -8% 0px' }
    );

    targets.forEach((target) => revealObserver.observe(target));

    return () => {
      revealObserver.disconnect();
    };
  }, []);

  useEffect(() => {
    const ids = eventsContent.nav.map((item) => item.id);
    const sections = ids
      .map((id) => document.getElementById(id))
      .filter(Boolean);

    if (!sections.length) return undefined;

    const sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSectionId(entry.target.id);
          }
        });
      },
      { threshold: 0.35, rootMargin: '-30% 0px -45% 0px' }
    );

    sections.forEach((section) => sectionObserver.observe(section));
    return () => sectionObserver.disconnect();
  }, []);

  const activeTrack = eventsContent.tracks.find((track) => track.id === activeTrackId);

  return (
    <main className="page-events page-events-redesign" id="top">
      <section className="events2026-hero" id="events-hero">
        <div className="events2026-hero-media" aria-hidden="true">
          <video
            className="events2026-hero-video"
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
            poster="/events/brochure-p2.png"
          >
            <source src="/events/events-hero-timeline.mp4" type="video/mp4" />
          </video>
          <div className="events2026-hero-overlay" />
        </div>

        <div className="events2026-hero-content">
          <div className="events2026-brand" aria-hidden="true">
            <img
              className="events2026-mark"
              src="/events/branding/hr-tech-asia-symbol-exact.png?v=1"
              alt=""
              loading="eager"
            />
            <span className="events2026-brand-wordmark">HR Tech Asia</span>
          </div>
          <p className="events2026-kicker">{eventsContent.hero.kicker}</p>
          <h1>{eventsContent.hero.title}</h1>
          <p className="events2026-meta">
            {eventsContent.hero.dates} | {eventsContent.hero.venue}
          </p>
          <div className="events2026-cta-row">
            <a
              className="button button-primary"
              href={eventsContent.finalCta.registerUrl}
              target="_blank"
              rel="noreferrer"
            >
              등록하기
            </a>
            <a className="button button-secondary" href={eventsContent.brochureUrl} target="_blank" rel="noreferrer">
              브로셔 다운로드
            </a>
          </div>
          <ul className="events2026-chip-row" aria-label="핵심 수치">
            {eventsContent.hero.chips.map((chip) => (
              <li key={chip}>{chip}</li>
            ))}
          </ul>
        </div>
      </section>

      <div className="events2026-sticky-wrap">
        <nav className="events2026-sticky-nav" aria-label="이벤트 페이지 섹션">
          {eventsContent.nav.map((item) => (
            <a
              key={item.id}
              className={activeSectionId === item.id ? 'is-active' : ''}
              href={`#${item.id}`}
            >
              {item.label}
            </a>
          ))}
        </nav>
      </div>

      <section className="events2026-section" id="events-why" data-reveal>
        <div className="events2026-section-head">
          <p className="eyebrow">Why Attend</p>
          <h2>{eventsContent.whyAttend.title}</h2>
          <p>{eventsContent.whyAttend.intro}</p>
        </div>
        <ul className="events2026-bullet-list">
          {eventsContent.whyAttend.bullets.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </section>

      <section className="events2026-section" id="events-tracks" data-reveal>
        <div className="events2026-section-head">
          <p className="eyebrow">Tracks</p>
          <h2>관심 트랙을 선택하고 세부 내용을 확인하세요</h2>
        </div>
        <div className="events2026-tabs" role="tablist" aria-label="트랙 탭">
          {eventsContent.tracks.map((track) => (
            <button
              key={track.id}
              type="button"
              role="tab"
              aria-selected={activeTrackId === track.id}
              className={activeTrackId === track.id ? 'is-active' : ''}
              onClick={() => setActiveTrackId(track.id)}
            >
              {track.tab}
            </button>
          ))}
        </div>
        {activeTrack ? (
          <article className="events2026-track-panel" role="tabpanel" aria-label={activeTrack.tab}>
            <p className="events2026-track-period">{activeTrack.period}</p>
            <p>{activeTrack.summary}</p>
            <details className="events2026-details">
              <summary>자세히 보기</summary>
              <ul>
                {activeTrack.details.map((detail) => (
                  <li key={detail}>{detail}</li>
                ))}
              </ul>
            </details>
          </article>
        ) : null}
      </section>

      <section className="events2026-section" id="events-programme" data-reveal>
        <div className="events2026-section-head">
          <p className="eyebrow">Program Highlights</p>
          <h2>날짜별 프로그램 흐름</h2>
        </div>
        <ol className="events2026-timeline">
          {eventsContent.programme.map((item) => (
            <li key={item.day} className="events2026-timeline-item">
              <div className="events2026-timeline-dot" aria-hidden="true" />
              <div className="events2026-timeline-body">
                <p>{item.day}</p>
                <h3>{item.title}</h3>
                <p>{item.summary}</p>
                <ul>
                  {item.highlights.map((highlight) => (
                    <li key={highlight}>{highlight}</li>
                  ))}
                </ul>
              </div>
            </li>
          ))}
        </ol>
      </section>

      <section className="events2026-section" id="events-demographics" data-reveal>
        <div className="events2026-section-head">
          <p className="eyebrow">Audience</p>
          <h2>참가자 구성과 지역 분포</h2>
        </div>
        <div className="events2026-demographics-grid">
          {eventsContent.demographics.groups.map((group) => (
            <article className="events2026-demographic-group" key={group.title}>
              <h3>{group.title}</h3>
              <ul>
                {group.bars.map((item) => (
                  <li key={item.label}>
                    <div className="events2026-demographic-label">
                      <span>{item.label}</span>
                      <strong>{item.value}%</strong>
                    </div>
                    <div className="events2026-bar">
                      <span style={{ width: `${item.value}%` }} />
                    </div>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
        <ul className="events2026-demographic-notes">
          {eventsContent.demographics.notes.map((note) => (
            <li key={note}>
              <span>{note}</span>
            </li>
          ))}
        </ul>
      </section>

      <section className="events2026-section" id="events-pricing" data-reveal>
        <div className="events2026-section-head">
          <p className="eyebrow">Pricing</p>
          <h2>참가 유형별 요금</h2>
        </div>

        <div className="events2026-pricing-table-wrap" aria-label="참가 요금표">
          <table className="events2026-pricing-table">
            <thead>
              <tr>
                <th>티켓 종류</th>
                <th>일정</th>
                <th>정가 (Regular)</th>
              </tr>
            </thead>
            <tbody>
              {eventsContent.pricing.tickets.map((ticket) => (
                <tr key={ticket.type}>
                  <td>{ticket.type}</td>
                  <td>{ticket.date}</td>
                  <td>{ticket.regular}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="events2026-pricing-footer">
          <div>
            <strong>단체 할인</strong>
            <ul>
              {eventsContent.pricing.groupDiscounts.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <small>{eventsContent.pricing.note}</small>
          </div>
          <div className="events2026-pricing-actions">
            <a
              className="button button-primary"
              href={eventsContent.finalCta.registerUrl}
              target="_blank"
              rel="noreferrer"
            >
              지금 등록하기
            </a>
          </div>
        </div>
      </section>

      <section className="events2026-section" id="events-testimonials" data-reveal>
        <div className="events2026-section-head">
          <p className="eyebrow">Testimonials</p>
          <h2>참가자 후기</h2>
        </div>
        <div className="events2026-testimonial-grid">
          {eventsContent.testimonials.map((item) => (
            <blockquote key={item.quote}>
              <p>{item.quote}</p>
              <cite>{item.author}</cite>
            </blockquote>
          ))}
        </div>
      </section>

    </main>
  );
}

function App() {
  const currentPage = getCurrentPage();
  const currentInsightSlug = getCurrentInsightSlug();
  const isEventsPage = currentPage === 'events';

  return (
    <div className="apple-shell">
      {!isEventsPage ? <VideoBackground /> : null}
      {!isEventsPage ? <TopFestivalBanner /> : null}
      {!isEventsPage ? <SiteHeader currentPage={currentPage} /> : null}
      {isEventsPage ? (
        <EventsPage />
      ) : currentPage === 'insights' ? (
        currentInsightSlug ? (
          <InsightsArticlePage slug={currentInsightSlug} />
        ) : (
          <InsightsPage />
        )
      ) : (
        <MainPage />
      )}
    </div>
  );
}

export default App;
